/* Decades v2 — header drawer + bundle swiper. Idempotent: safe to load once per page. */
(function () {
  if (window.__dv2Init) return;
  window.__dv2Init = true;

  function initDrawer() {
    var drawer = document.querySelector('.dv2-mobile-drawer');
    var backdrop = document.querySelector('.dv2-drawer-backdrop');
    var toggle = document.querySelector('.dv2-menu-toggle');
    var close = document.querySelector('.dv2-drawer-close');
    if (!drawer || !backdrop || !toggle) return;
    function setDrawer(open) {
      drawer.classList.toggle('dv2-open', open);
      backdrop.classList.toggle('dv2-open', open);
      toggle.setAttribute('aria-expanded', open);
      document.body.style.overflow = open ? 'hidden' : '';
    }
    toggle.addEventListener('click', function () {
      setDrawer(!drawer.classList.contains('dv2-open'));
    });
    backdrop.addEventListener('click', function () { setDrawer(false); });
    if (close) close.addEventListener('click', function () { setDrawer(false); });
    drawer.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { setDrawer(false); });
    });
  }

  function initBundleSliders() {
    document.querySelectorAll('.dv2-bundle-slider').forEach(function (root) {
      var row = root.querySelector('.dv2-bundle-row');
      var prev = root.querySelector('.dv2-bundle-prev');
      var next = root.querySelector('.dv2-bundle-next');
      var dots = Array.prototype.slice.call(root.querySelectorAll('.dv2-bundle-dots span'));
      if (!row) return;
      function step() {
        var card = row.querySelector('.dv2-bundle-card');
        return card ? card.offsetWidth + 12 : 300;
      }
      if (prev) prev.addEventListener('click', function () { row.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { row.scrollBy({ left: step(), behavior: 'smooth' }); });
      function updateDots() {
        if (!dots.length) return;
        var i = Math.min(dots.length - 1, Math.max(0, Math.round(row.scrollLeft / step())));
        dots.forEach(function (d, j) { d.classList.toggle('dv2-active', j === i); });
      }
      row.addEventListener('scroll', function () { requestAnimationFrame(updateDots); }, { passive: true });
      updateDots();
    });
  }

  function initSearch() {
    var toggle = document.querySelector('.dv2-search-toggle');
    var panel = document.querySelector('.dv2-search-panel');
    if (!toggle || !panel || toggle.__dv2Bound) return;
    toggle.__dv2Bound = true;
    var input = panel.querySelector('.dv2-search-input');
    var results = panel.querySelector('.dv2-search-results');
    var close = panel.querySelector('.dv2-search-close');
    var timer = null;
    function setOpen(open) {
      panel.hidden = !open;
      toggle.setAttribute('aria-expanded', open);
      if (open) input.focus();
    }
    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      setOpen(panel.hidden);
    });
    close.addEventListener('click', function () { setOpen(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setOpen(false); });
    document.addEventListener('click', function (e) {
      if (!panel.hidden && !panel.contains(e.target) && !toggle.contains(e.target)) setOpen(false);
    });
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }
      timer = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var products = (d.resources && d.resources.results && d.resources.results.products) || [];
            if (!products.length) {
              results.innerHTML = '<div class="dv2-sr-empty">No products found for "' + q.replace(/[<>&"]/g, '') + '"</div>';
              return;
            }
            results.innerHTML = products.map(function (p) {
              var img = p.featured_image && p.featured_image.url ? '<img src="' + p.featured_image.url + '&width=88" alt="" loading="lazy">' : '';
              if (img.indexOf('?') === -1) img = img.replace('&width=88', '?width=88');
              return '<a href="' + p.url + '">' + img + '<span class="dv2-sr-title">' + p.title + '</span><span class="dv2-sr-price">' + (p.price ? '$' + p.price : '') + '</span></a>';
            }).join('');
          })
          .catch(function () { results.innerHTML = ''; });
      }, 220);
    });
  }

  /* catalogue: ?benefit= activates the matching native goal chip, so the
     selection is highlighted, "All Products" unselects, and the filter is
     clearable through the normal chip UI */
  var BENEFIT_CHIP_MAP = {
    longevity: 'goals:longevity',
    brain: 'goals:brain-focus',
    rest: 'goals:rest-recovery',
    metabolic: 'goals:metabolic-health'
  };
  function initBenefitFilter() {
    var params = new URLSearchParams(location.search);
    var target = null;
    var benefit = params.get('benefit');
    if (benefit && BENEFIT_CHIP_MAP[benefit]) target = BENEFIT_CHIP_MAP[benefit];
    if (params.get('type') === 'bundle') target = 'type:bundle';
    if (!target) return;
    var chip = document.querySelector('[data-chip="' + target + '"]');
    if (chip && !chip.classList.contains('is-active')) chip.click();
  }

  function init() {
    initDrawer();
    initBundleSliders();
    initSearch();
    initBenefitFilter();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  /* Shopify theme editor re-renders sections; re-init on section load */
  document.addEventListener('shopify:section:load', function () {
    initDrawer();
    initBundleSliders();
  });
})();
